/**
 * The billing cycle a plan period covers, mirroring the backend's
 * cycle_start_for / cycle_end_for (backend/api/services/ad_spend_pacing_link.py):
 * a day-15 client's "October" runs Oct 15 - Nov 14; a day-1 client's runs
 * Oct 1 - Oct 31. Any day other than 15 is the 1st, as pacing assumes (D4).
 */

type Ymd = [number, number, number];

function bounds(period: string, day: number): [Ymd, Ymd] {
  const [y, m] = period.split("-").map(Number);
  if (day === 15) {
    const [ny, nm] = m === 12 ? [y + 1, 1] : [y, m + 1];
    return [[y, m, 15], [ny, nm, 14]];
  }
  return [[y, m, 1], [y, m, new Date(y, m, 0).getDate()]]; // day 0 of next month
}

const iso = ([y, m, d]: Ymd) =>
  `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

const short = ([y, m, d]: Ymd) =>
  new Date(y, m - 1, d).toLocaleString("en-US", { month: "short", day: "numeric" });

/** `period` is 'YYYY-MM'; returns ISO dates. */
export function cycleRange(period: string, day: number): { start: string; end: string } {
  const [start, end] = bounds(period, day);
  return { start: iso(start), end: iso(end) };
}

/** "Oct 15 – Nov 14" for display. */
export function formatCycleRange(period: string, day: number): string {
  const [start, end] = bounds(period, day);
  return `${short(start)} – ${short(end)}`;
}
